export const analyticsId = {
  REJECTED_VIEW: 'REJECTED_VIEW',
  MIGRATE_LINK: 'MIGRATE_LINK',
  EXIT_BUTTON: 'EXIT_BUTTON',
  PHONE_LINK: 'PHONE_LINK',
};

export const catalogue = {
  [analyticsId.REJECTED_VIEW]: () => ({
    pageName: '/migrationRejected',
    sectionFamily: 'banking',
    sectionCategory: 'services',
    sectionName: 'customer',
    interactionType: 'funnel',
    serviceType: 'userSettings',
    nombrePagina: 'migracion rechazada',
    tipoPagina: 'generica',
  }),
  [analyticsId.MIGRATE_LINK]: () => ({
    categoriaEvento: 'interaccion en migracion rechazada',
    accionEvento: 'quiero migrar al nuevo banco',
    action: 'click',
    format: 'link',
    component: 'lowerNavigation',
    element: 'IWantToMigrateToTheNewBank',
  }),
  [analyticsId.EXIT_BUTTON]: () => ({
    categoriaEvento: 'interaccion en migracion rechazada',
    accionEvento: 'salir',
    action: 'exit',
    format: 'button',
    component: 'lowerNavigation',
    element: 'exit',
  }),
  [analyticsId.PHONE_LINK]: () => ({
    categoriaEvento: 'interaccion en migracion rechazada',
    accionEvento: 'call center',
    action: 'click',
    format: 'link',
    component: 'confirmationMessage',
    element: 'callCenter',
  }),
};
